var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-xl"},[_c('div',{staticClass:"card h-full"},[_c('div',{staticClass:"card-table table-responsive align-items-center",attrs:{"align":"center"}},[_c('img',{attrs:{"width":"200","src":_vm.ic_error_user}}),_c('h3',[_vm._v("Oops")]),_c('p',[_vm._v(" Forbidden. You do not have access to this page :) ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }